import React from 'react';
import { Bar, Line, Pie, Doughnut, PolarArea, Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement, 
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement, 
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Filler
);
const chartTypeMap = {
  bar: Bar,
  line: Line,
  pie: Pie,
  doughnut: Doughnut,
  polar: PolarArea,
  radar: Radar,
};

function getChartType(widget) {
  return (
    widget?.config?.visualization?.chartType ||
    widget?.config?.chartType ||
    widget?.data?.chart?.type ||
    widget?.type ||
    'bar'
  ).toLowerCase();
}

function getChartData(widget) {
  return widget?.data?.chart || widget?.data;
}

function getChartOptions(widget, compact, isResizable) {
  const visualization = widget?.config?.visualization || {};
  return {
    responsive: true,
    maintainAspectRatio: !isResizable,
    plugins: {
      legend: {
        display: visualization.displayLegend !== false,
        position: 'top',
        labels: {
          boxWidth: compact ? 8 : 12,
          padding: compact ? 8 : 15,
          font: { size: compact ? 10 : 12 },
        },
      },
      tooltip: {
        enabled: visualization.tooltips?.enabled !== false,
        titleFont: { size: compact ? 11 : 14 },
        bodyFont: { size: compact ? 10 : 13 },
      },
    },
    scales: !['pie', 'doughnut', 'polararea', 'radar'].includes(getChartType(widget))
      ? {
          x: {
            display: true,
            grid: { display: visualization.gridLines !== false },
            ticks: { font: { size: compact ? 9 : 11 }, maxRotation: 45 },
          },
          y: {
            display: true,
            beginAtZero: true,
            grid: { display: visualization.gridLines !== false },
            ticks: { precision: 0, font: { size: compact ? 9 : 11 } },
          },
        }
      : undefined,
  };
}

const ChartWidget = ({ widget, compact = false, isResizable = false }) => {
  const chartType = getChartType(widget);
  const ChartComponent = chartTypeMap[chartType] || Bar;
  const chartData = getChartData(widget);
  const options = getChartOptions(widget, compact, isResizable);
  const chartHeight = compact ? '120px' : isResizable ? '100%' : '250px';

  if (!chartData?.labels || !chartData?.datasets) {
    return <div className="text-gray-500 p-4">No chart data available</div>;
  }

  return (
    <div style={{ height: chartHeight }}>
      <ChartComponent data={chartData} options={options} />
    </div>
  );
};

export default ChartWidget;